export default "__VITE_ASSET__DYiQ6KSP__"